import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
//import headerImg from "../assets/img/header-img.svg";
import headerImg from "../assets/img/header-image.png";
//import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {

    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const [index, setIndex] = useState(1);
    const toRotate = [ "Web Developer", "Mobile App Developer", "Software Developer" ];
    const period = 2000;

    useEffect(() => {
        let ticker = setInterval(() => {
        tick();
        }, delta);

        return () => { clearInterval(ticker) };
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
        setDelta(prevDelta => prevDelta / 2);
        }

        if (!isDeleting && updatedText === fullText) {
        setIsDeleting(true);
        setIndex(prevIndex => prevIndex - 1);
        setDelta(period);
        } else if (isDeleting && updatedText === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setIndex(1);
        setDelta(500);
        } else {
        setIndex(prevIndex => prevIndex + 1);
        }
    }

    return (
        <section className="banner" id="home">
        <Container>
            <Row className="aligh-items-center">
            <Col xs={12} md={6} xl={7}>
                <TrackVisibility>
                {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                    <span className="tagline">Web Design and Development Services</span>
                    <h5>Involves creating and maintaining websites for businesses and organizations. This includes designing the website layout, graphics, and user experience, as well as developing and coding the functionality of the site. Services also include optimizing the website for search engines and mobile devices, and maintaining and updating the site on an ongoing basis.</h5>
                    {/* <h3>We specialize in creating responsive websites and custom web applications for businesses and organizations.</h3> */}
                    <h1>
                        <span className="txt-rotate" dataPeriod="1000" data-rotate='["Web Developer", "Mobile Developer", "Web Designer"]'><span className="wrap">{text}</span></span>
                    </h1>
                    
                    {/* <p>Static and Dynamic Website. This two types of websites offered by various companies and freelancers today.</p>
                    <p>Static Websites simply means that the information or 'code' that makes up the website doesn't change, these websites can only be edited by a programmer.</p>
                    <p>Dynamic Websites means that the data or content can change 'dynamically'. These web pages can be edited by anybody, you do not need to pay a programmer to maintain them.</p> */}

                </div>}
                </TrackVisibility>
            </Col>
            <Col xs={12} md={6} xl={5}>
                <TrackVisibility>
                {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={headerImg} alt="Header Img"/>
                    </div>}
                </TrackVisibility>
            </Col>
            </Row>
        </Container>
        </section>
    )
}